module.exports = __webpack_public_path__ + "img/GL.a6e31892.jpg";